/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeoCustomerNumber
 */
export interface HeoCustomerNumber {
    /**
     * 
     * @type {string}
     * @memberof HeoCustomerNumber
     */
    companyCode: string;
    /**
     * 
     * @type {number}
     * @memberof HeoCustomerNumber
     */
    number: number;
}

/**
 * Check if a given object implements the HeoCustomerNumber interface.
 */
export function instanceOfHeoCustomerNumber(value: object): value is HeoCustomerNumber {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function HeoCustomerNumberFromJSON(json: any): HeoCustomerNumber {
    return HeoCustomerNumberFromJSONTyped(json, false);
}

export function HeoCustomerNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeoCustomerNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCode': json['companyCode'],
        'number': json['number'],
    };
}

export function HeoCustomerNumberToJSON(json: any): HeoCustomerNumber {
    return HeoCustomerNumberToJSONTyped(json, false);
}

export function HeoCustomerNumberToJSONTyped(value?: HeoCustomerNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyCode': value['companyCode'],
        'number': value['number'],
    };
}

